<template>
  <v-form @submit.prevent="updateRunner" novalidate>
    <v-toolbar flat dense dark color="primary">
      <v-toolbar-title>OSOBOWE</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="accent" small v-if="isActiveRunner || isAdmin" @click.prevent="updateMode = !updateMode">edytuj</v-btn>
      <v-btn color="light-blue darken-3" v-if="isActiveRunner" small :to="{name: 'runner-change-password'}">zmień hasło</v-btn>
    </v-toolbar>
    <v-layout row wrap>
      <v-flex xs12 sm6 md4 lg3 class="text-xs-center mt-5">
        <div role="group" v-if="updateMode">
          <picture-input
            ref="pictureInput"
            @change="changeAvatar"
            width="200"
            height="200"
            margin="8"
            size="10"
            buttonClass="btn btn-outline-secondary"
            :customStrings="{
              upload: '<p>Urządzenie nie obsługiwane.</p>',
              drag: 'Upuść plik lub <br/>kliknij aby wybrać',
              tap: 'Dotknij aby wybrać zdjęcie<br>z Twojej galerii',
              change: 'Zmień obraz',
              remove: 'Usuń obraz',
              select: 'Wybierz obraz',
              selected: '<p>Photo successfully selected!</p>',
              fileSize: 'The file size exceeds the limit',
              fileType: 'This file type is not supported.',
              aspect: 'Landscape/Portrait'
            }">
          </picture-input>
        </div>
        <img width="200" v-if="!updateMode && runner.avatar_thumbnail" class="d-inline-block avatar" id="avatar_thumbnailInput" :src="runner.avatar_thumbnail" />
        <img width="200" v-if="!updateMode && !runner.avatar_thumbnail" class="d-inline-block avatar" id="avatar_thumbnailInput" src="@/assets/img/avatar.png" />
      </v-flex>
      <v-flex xs12 sm6 md5 lg4>
        <v-list two-line>
          <runner-data-field
            :editable="updateMode"
            label="Imię"
            required
            v-model="form.first_name"
            :objValue="runner.first_name"
            :formErrors="formErrors"
            :field="'first_name'"></runner-data-field>
          <runner-data-field
            :editable="updateMode"
            label="Nazwisko"
            required
            v-model="form.last_name"
            :objValue="runner.last_name"
            :formErrors="formErrors"
            :field="'last_name'"></runner-data-field>
          <runner-data-field
            :editable="updateMode"
            label="Telefon"
            v-model="form.phone"
            :objValue="runner.phone"
            :formErrors="formErrors"
            :field="'phone'">
            <a :href="'tel:' + runner.phone" slot="value">{{runner.phone}}</a>
          </runner-data-field>
          <runner-data-field
            :editable="false"
            label="Email"
            :objValue="runner.email"
            :field="'email'">
              <a :href="'mailto:' + runner.email" slot="value">{{runner.email}}</a>
          </runner-data-field>
        </v-list>
        <v-btn v-if="updateMode" type="submit" color="primary">Zapisz</v-btn>
      </v-flex>
      <v-flex xs12 sm6 md5 lg4 offset-sm6 offset-md4 offset-lg0>
        <v-list two-line>
          <runner-data-field
            :editable="updateMode"
            label="Pakiet"
            v-model="form.package"
            :objValue="runner.package_name"
            :formErrors="formErrors"
            :field="'package'">
              <template slot-scope="{ error, label}">
                <v-select
                  v-model="form.package"
                  :error="error"
                  :label="label"
                  :items="allPackagesOptions">
                </v-select>
              </template>
          </runner-data-field>
          <runner-data-field
            :editable="updateMode"
            label="Trener"
            v-model="runner.trainer_name"
            :objValue="runner.trainer_name"
            :formErrors="formErrors"
            :props="{disabled: true}"
            description="Aby zmienić trenera skontaktuj się z obsługą"
            :field="'trainer'"></runner-data-field>
        </v-list>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import {updateRunnerData} from './api'
import {Validator} from 'simple-vue-validator'
import {serverValidation} from '@/utils/form-utils'
import * as types from '@/store/mutation-types'
import iziToast from 'izitoast'
import PictureInput from 'vue-picture-input'
import { mapGetters } from 'vuex'
import RunnerDataField from './RunnerDataField'

export default {
  components: {PictureInput, RunnerDataField},
  validators: {
    'runner.avatar_thumbnail': function (value) {
      value = value || null
      return Validator.value(value).custom(serverValidation(this.formErrors, 'avatar_thumbnail'))
    }
  },
  props: {
    runner: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      updateMode: false,
      form: {},
      formErrors: {}
    }
  },
  computed: {
    ...mapGetters(['allPackagesOptions', 'isAdmin', 'isActiveRunner'])
  },
  created () {
    this.form = {...this.runner}
    this.$store.dispatch(types.ALL_PACKAGES_REQUEST)
  },
  watch: {
    'runner': function (oldVar, newVar) {
      this.form = {...this.runner}
    }
  },
  methods: {
    changeAvatar (image) {
      this.form.avatar_thumbnail = this.$refs.pictureInput.file
    },
    updateRunner () {
      this.$validate().then(success => {
        if (success) {
          updateRunnerData(this.form).then((data) => {
            this.validation.reset()
            this.$emit('runner-updated', data)
            iziToast.show({
              message: 'Konto zawodnika zostało edytowane.',
              color: 'green'
            })
            this.updateMode = false
            return data
          }).catch((data) => {
            if (data.response.status === 400) {
              this.formErrors = data.response.data
              this.$validate()
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/runners/RunnerDataPersonal.vue